// React
import React from 'react';
import 'cleave.js/dist/addons/cleave-phone.in';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  createData,
  InputPhone,
  PageWrapper,
  SelectInput,
  ZipCodeInput,
  InputCpfCnpj,
  SelectInputWithSearchApi,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const OrganizationsFormPage = ({
  id,
  history,
  isActive,
  validation,
  setIsActive,
  organizationsByHash,
  categoryOrganizations,
  handleGenerateTemporaryPassword,
}) => {
  return (
    <PageWrapper title={id ? 'Editar Organização' : 'Nova Organização'}>
      <Row>
        <Col>
          <Card>
            <div className="live-preview">
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <h5>Principal</h5>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <label
                          htmlFor="cleave-delimiters"
                          className="form-label"
                        >
                          CNPJ
                        </label>
                        <InputCpfCnpj
                          id="cnpjInput"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.cnpjInput || ''}
                          invalid={
                            !!(
                              validation.touched.cnpjInput &&
                              validation.errors.cnpjInput
                            )
                          }
                        />
                        {validation.touched.cnpjInput &&
                        validation.errors.cnpjInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.cnpjInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Nome
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="categoryInput" className="form-label">
                          Categoria
                        </Label>
                        <SelectInput
                          invalid={
                            !!(
                              validation.touched.categoryInput &&
                              validation.errors.categoryInput
                            )
                          }
                          isClearable
                          className="form-control"
                          inputId="categoryInput"
                          value={validation.values.categoryInput}
                          onChange={(eventInput) => {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'categoryInput',
                                eventInput
                              )
                            );
                          }}
                          onBlur={(eventInput) => {
                            validation.handleBlur(
                              convertEventSelectToTarget(
                                'categoryInput',
                                eventInput
                              )
                            );
                          }}
                          placeholder="Selecione uma categoria"
                          options={createData(categoryOrganizations)}
                        />
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="address1ControlTextarea"
                          className="form-label"
                        >
                          Observações
                        </Label>
                        <textarea
                          className="form-control"
                          id="obsInput"
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.obsInput || ''}
                        ></textarea>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <h5>Contato</h5>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="citynameInput" className="form-label">
                          Email
                        </Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="emailInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="phoneInput" className="form-label">
                          Celular
                        </Label>
                        <InputPhone
                          id="phoneInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phoneInput || ''}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="siteInput" className="form-label">
                          Site
                        </Label>
                        <Input
                          type="url"
                          className="form-control"
                          id="siteInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.siteInput || ''}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="emailRHInput" className="form-label">
                          Email do RH
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="emailRHInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailRHInput || ''}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label
                          htmlFor="responsibleInput"
                          className="form-label"
                        >
                          Responsável
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="responsibleInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.responsibleInput || ''}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="citynameInput" className="form-label">
                          Telefone
                        </Label>
                        <InputPhone
                          id="telInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.telInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="citynameInput" className="form-label">
                          Whatsapp
                        </Label>
                        <InputPhone
                          id="whatsappInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.whatsappInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="mb-3">
                        <h5>Endereço</h5>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          CEP
                        </Label>
                        <ZipCodeInput
                          id="zipInput"
                          className="form-control"
                          changeInputs={(e) => {
                            validation.setValues({
                              ...validation.values,
                              zipInput: e.cep,
                              streetInput: e.logradouro,
                              neighborhoodInput: e.bairro,
                              address2Input: e.complemento,
                              cityInput: {
                                label: `${e.localidade} - ${e.uf} `,
                                value: e.ibge,
                              },
                            });
                          }}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          value={validation.values.zipInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Logradouro
                        </Label>
                        <Input
                          className="form-control"
                          id="streetInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.streetInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Número
                        </Label>
                        <Input
                          className="form-control"
                          id="numberInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.numberInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Complemento
                        </Label>
                        <Input
                          className="form-control"
                          id="address2Input"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address2Input || ''}
                        />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Bairro
                        </Label>
                        <Input
                          className="form-control"
                          id="neighborhoodInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.neighborhoodInput || ''}
                        />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Cidade
                        </Label>
                        <SelectInputWithSearchApi validation={validation} />
                      </div>
                    </Col>

                    <Col lg={4} md={6}>
                      <div className="mt-4 mt-md-0 mb-3">
                        <div>
                          <div className="form-check form-switch form-check-right mb-2">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="isActiveSelect"
                              onChange={() => setIsActive(!isActive)}
                              onBlur={validation.handleBlur}
                              checked={isActive}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckRightDisabled"
                            >
                              Ativo
                            </Label>
                          </div>
                        </div>
                      </div>
                    </Col>

                    {organizationsByHash.hashid && (
                      <div className="border-top border-top-dashed">
                        <Col md={12} className="mt-3 mb-3">
                          <div>
                            <h5>Acesso a Plataforma</h5>
                          </div>
                        </Col>

                        <Col md={4}>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm waves-effect d-flex align-items-center"
                            onClick={() =>
                              handleGenerateTemporaryPassword(
                                organizationsByHash.hashid
                              )
                            }
                          >
                            Gerar Nova Senha de Acesso
                            <i className="ri-lock-line fs-14 mx-1"></i>
                          </button>
                        </Col>

                        <Col md={12} className="mt-3">
                          <div className="d-flex align-items-center justify-content-start">
                            <div>
                              <i className="ri-shield-user-line fs-16"></i>
                            </div>
                            <div className="d-grid align-items-center mx-2">
                              <span className="text-muted">Último Acesso:</span>

                              <span className="fw-bold">
                                {organizationsByHash.last_login ||
                                  'Ainda não houve acesso '}
                              </span>
                            </div>
                          </div>
                        </Col>
                      </div>
                    )}
                  </Row>
                </CardBody>

                <CardFooter>
                  <Col md={12}>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="card-text">
                        <small className="text-muted">
                          {organizationsByHash?.last_update}
                        </small>
                      </span>
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-link me-3"
                          onClick={() => {
                            history.push('/organizacoes');
                          }}
                        >
                          Cancelar
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Salvar
                        </button>
                      </div>
                    </div>
                  </Col>
                </CardFooter>
              </Form>
            </div>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
